import SelectMultiple from './SelectMultiple';
const els = document.querySelectorAll('.select-multiple__inner');

for (let i = 0; i < els.length; i++) {
    new SelectMultiple(els[i]);
}
